import { Tooltip } from "antd";
import { clsx } from "clsx";

import { RVIcon, RVIconSizeOptions } from "@regal-voice/ui";

import styles from "./DrawerPanelIcon.module.scss";

type DrawerPanelIconProps = {
    icon: string;
    danger?: boolean;
    edit?: boolean;
    tooltip?: string;
    onClick?: () => void;
    buttonClassName?: string;
    className?: string;
};

export function DrawerPanelIcon({
    icon,
    danger,
    edit,
    tooltip,
    onClick,
    buttonClassName,
    className,
}: DrawerPanelIconProps): JSX.Element {
    function getClickHandler() {
        if (!!onClick) {
            return function (event: React.MouseEvent<HTMLElement>) {
                // prevent the panel from being collapsed/expanded
                event.stopPropagation();
                onClick();
            };
        }
    }

    const iconComponent = (
        <RVIcon
            data-testid={`drawer-panel-icon-${icon}`}
            className={clsx(styles.icon, styles.panelIcon, { [styles.danger]: danger, [styles.edit]: edit })}
            icon={icon}
            size={RVIconSizeOptions.SMALL}
        />
    );

    const wrappedInTooltip = tooltip ? (
        <Tooltip placement="top" title={tooltip}>
            {iconComponent}
        </Tooltip>
    ) : (
        iconComponent
    );

    return (
        <span className={clsx(styles.wrapper, className)}>
            {onClick ? (
                <button type="button" onClick={getClickHandler()} className={clsx(styles.panelButton, buttonClassName)}>
                    {wrappedInTooltip}
                </button>
            ) : (
                wrappedInTooltip
            )}
        </span>
    );
}
